var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTorqaiLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 29,
    viewBox: "0 0 164 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8014_4027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.3172 14.5173C57.3172 22.4096 50.8314 28.8142 42.8741 28.8142C34.9168 28.8142 28.3961 22.4096 28.3961 14.5173C28.3961 6.62495 34.8818 0.254913 42.8741 0.254913C50.8664 0.254913 57.3172 6.65951 57.3172 14.5173ZM53.286 14.5173C53.286 8.87455 48.5883 4.23564 42.8741 4.23564C37.1599 4.23564 32.4622 8.87455 32.4622 14.5173C32.4622 20.16 37.1249 24.7989 42.8741 24.7989C48.6233 24.7989 53.286 20.1946 53.286 14.5173Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.527 28.8142H150.226L140.539 4.69507L130.852 28.8142H126.55L138.121 0H142.956L154.527 28.8142Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164 0.254913H160.001V28.8142H164V0.254913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.568 0.254913H9.56891V28.8142H13.568V0.254913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1369 0.286606H0V4.23565H23.1369V0.286606Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5769 17.4078H62.5764V28.8142H66.5769V17.4078Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9106 28.8142H86.8712L77.0909 16.836C77.0777 16.8231 77.0675 16.8087 77.0631 16.7928L86.9121 28.8142H86.9106Z",
    fill: "#1D1429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.926 28.8905H118.266L115.434 26.0922L115.355 26.013L112.463 23.1571L112.384 23.0779L106.099 16.872H111.755L115.294 20.366L118.183 23.219L118.261 23.2968L120.748 25.7523L122.457 27.4431H122.46L123.926 28.8905Z",
    fill: "url(#paint0_linear_8014_4027)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.355 26.013L115.434 26.0908L115.429 26.0936L112.378 23.0793C112.378 23.0793 112.381 23.0764 112.382 23.0764L112.461 23.1571L115.353 26.013H115.355Z",
    fill: "#1D1429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.216 20.2824L118.264 23.2953L118.261 23.2982L118.183 23.2204L115.294 20.3674L115.215 20.2896C115.215 20.2896 115.218 20.2867 115.218 20.2853L115.216 20.2824Z",
    fill: "#1D1429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.215 14.6123C121.215 15.39 121.154 16.1548 121.033 16.8893C120.722 18.8379 119.993 20.7174 118.903 22.3866L115.798 19.3175V19.3146C116.211 18.5355 116.517 17.7102 116.713 16.8461C116.88 16.1058 116.966 15.3526 116.966 14.6037C116.966 8.984 112.336 4.41423 106.645 4.41423C100.954 4.41423 96.3235 8.98544 96.3235 14.6037C96.3235 15.3526 96.4095 16.1058 96.5772 16.8461C97.6215 21.4533 101.855 24.796 106.645 24.796C108.315 24.796 109.94 24.4014 111.404 23.6496L114.513 26.7245C112.224 28.1805 109.59 28.9626 106.835 28.9971H106.46C99.341 28.9107 93.3672 23.8167 92.2573 16.8879C92.1333 16.1462 92.0721 15.38 92.0721 14.6109C92.0721 6.67823 98.6089 0.221786 106.645 0.221786C114.681 0.221786 121.216 6.67679 121.216 14.6109L121.215 14.6123Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8712 28.8128H81.6296C81.2766 28.3836 80.9237 27.953 80.5737 27.5238C79.7555 26.5272 78.9402 25.5305 78.1249 24.5354C77.9951 24.3769 77.8668 24.22 77.7413 24.0615L75.6514 21.7529L75.5814 21.6751L72.9984 18.8192L72.9284 18.7385L67.3163 12.5341H72.3684L72.3771 12.5456H77.4744C79.824 12.5456 81.7521 10.6071 81.6791 8.25383C81.6106 6.00278 79.579 4.23565 77.2994 4.23565H62.5749V0.253479H77.4744C82.3471 0.253479 86.2047 4.40847 85.6797 9.28789C85.2217 13.4803 81.4706 16.5249 77.2294 16.5249C77.1055 16.5249 77.0106 16.6834 77.0617 16.7928C77.0661 16.8087 77.0777 16.8231 77.0909 16.836L86.8698 28.8128H86.8712Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8014_4027",
    x1: 106.099,
    y1: 22.882,
    x2: 123.926,
    y2: 22.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70C7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#759DD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#A068A9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8014_4027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 164,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTorqaiLogo);
export default __webpack_public_path__ + "static/media/torqai-logo.d068721d2837225ce2ee613c650676f3.svg";
export { ForwardRef as ReactComponent };